import { useEffect, useState } from "react";
import { UserCheck } from "lucide-react";
import api from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";

/** Pick who reviews this article or snippet — any active staff member except
 *  yourself (nobody reviews their own work). Required before saving content.
 *  Super admins may name themself and may leave it empty (they can publish
 *  without a review); the amber "required" styling is dropped for them. */
export const KbReviewerSelect = ({ value, onChange, testid = "kb-reviewer-select", className = "", compact = false, allowSelf }) => {
  const { user } = useAuth();
  const isAdmin = user?.role === "super_admin";
  const selfOk = allowSelf ?? isAdmin;
  const [staff, setStaff] = useState([]);
  useEffect(() => {
    api.get("/kb/editors").then((r) => setStaff(r.data.editors || [])).catch(() => {});
  }, []);
  const options = selfOk ? staff : staff.filter((e) => e.user_id !== user?.user_id);
  const missing = !value && !isAdmin;
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger data-testid={testid}
        className={`${compact ? "h-8 w-[220px] text-xs" : "h-9 text-sm"} ${missing ? "border-amber-400 ring-1 ring-amber-200" : ""} ${className}`}
        aria-invalid={missing}>
        <span className="flex min-w-0 items-center gap-1.5">
          <UserCheck className={`h-3.5 w-3.5 shrink-0 ${missing ? "text-amber-500" : "text-primary"}`} />
          <SelectValue placeholder={isAdmin ? "Reviewer (optional)" : "Reviewer (required)"} />
        </span>
      </SelectTrigger>
      <SelectContent>
        {options.map((e) => (
          <SelectItem key={e.user_id} value={e.user_id} data-testid={`${testid}-${e.user_id}`}>
            {e.name}{e.user_id === user?.user_id ? " (you)" : ""}{e.team ? ` — ${e.team}` : ""}
          </SelectItem>
        ))}
        {!options.length && <div className="px-2 py-1.5 text-xs text-slate-400">No other staff members found</div>}
      </SelectContent>
    </Select>
  );
};
